import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgUiKitModule } from '@infocert/ng-ui-kit';
import { FormlyModule } from '@ngx-formly/core';
import { SharedModule } from '@shared';

import { ModalModule } from 'ngx-bootstrap/modal';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { ConfirmationCodeComponent } from './confirmation-code/confirmation-code.component';
import { ConfirmPinInputComponent } from './confirm-pin-input/confirm-pin-input.component';
import { InputOtpType } from './forms/input-otp-type';
import { HostDirective } from './host.directive';
import { HTMLTranslateDirective } from './HTMLtranslate';
import { LoadingComponent } from './loading/loading.component';
import { ModalComponent } from './modal/modal.component';
import { OnlyNumbersDirective } from './only-numbers.directive';
import { OtpInputComponent } from './otp-input/otp-input.component';
import { PinInputComponent } from './pin-input/pin-input.component';
import { PageWrapperComponent } from './page-wrapper/page-wrapper.component';
import { SubmitButtonComponent } from './submit-button/submit-button.component';
import { TranslateKeyAttributeDirective } from './translate-key';
import { UserDetailsComponent } from './user-details/user-details.component';
import { FieldValidatorComponent } from './validators/field-validator/field-validator.component';

@NgModule({
  declarations: [
    UserDetailsComponent,
    BreadcrumbsComponent,
    FieldValidatorComponent,
    LoadingComponent,
    OtpInputComponent,
    ConfirmationCodeComponent,
    ConfirmPinInputComponent,
    ModalComponent,
    HostDirective,
    SubmitButtonComponent,
    PageWrapperComponent,
    OnlyNumbersDirective,
    TranslateKeyAttributeDirective,
    HTMLTranslateDirective,
    InputOtpType,
    PinInputComponent,
  ],
  exports: [
    UserDetailsComponent,
    BreadcrumbsComponent,
    FieldValidatorComponent,
    LoadingComponent,
    OtpInputComponent,
    ConfirmationCodeComponent,
    ConfirmPinInputComponent,
    PinInputComponent,
    ModalComponent,
    HostDirective,
    NgUiKitModule,
    SubmitButtonComponent,
    PageWrapperComponent,
    OnlyNumbersDirective,
    TranslateKeyAttributeDirective,
    HTMLTranslateDirective,
    InputOtpType,
  ],
  imports: [
    CommonModule,
    RouterModule,
    ModalModule.forRoot(),
    NgUiKitModule,
    SharedModule,
    FormlyModule,
  ],
})
export class CommonsModule {}
